var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEditPencilNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 21.6902H18.4312H3.2002Z",
    fill: "#525059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2002 21.6902H18.4312",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5079 16.8093L7.354 17.5432L8.08094 13.3824L17.3677 4.09559C17.6274 3.83601 17.9795 3.69019 18.3466 3.69019C18.7138 3.69019 19.0659 3.83601 19.3256 4.09559L20.7947 5.56469C21.0543 5.82435 21.2001 6.17647 21.2001 6.54363C21.2001 6.91079 21.0543 7.26291 20.7947 7.52257L11.5079 16.8093Z",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditPencilNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/editPencilNew.65d5ddf9.svg";
export { ForwardRef as ReactComponent };